import React from 'react';
import './PlaceItem.css';
import config from '../../../../config.json';

const PlaceItem = ({number, id, image, areaName, placeCategoryName, deletePlace, getPlaceInfo,
    deleteLoading, fetchLoading, updateLoading, getPlaceInfoForUpdate, title, telephone}) => {
        
    return ( 
        <div className="place-item-layer">
            <span className="align-self-center place-item-layer-number">
                <span>{number}</span>
            </span>
            <span className="image-rect align-self-center">
                <img src={`${config.api_server}/${image}`} alt="" className="" />
            </span>
            <div className="align-self-center d-flex flex-column justify-content-between align-items-start px-2 py-1">
                <small className="font-weight-bold">
                    <span >عنوان</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{title}</span>
                </small>
                <small className="font-weight-bold">
                    <span >محدوده جغرافیایی</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{areaName}</span>
                </small>
                <small className="font-weight-bold">
                    <span >دسته بندی</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{placeCategoryName}</span>
                </small>
                <small className="font-weight-bold">
                    <span >تلفن</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{telephone}</span>
                </small>
            </div>
            <div className="d-flex justify-content-center align-items-center flex-md-column small-margin-auto">
                <button className="btn btn-primary mr-1 mr-md-0  mb-md-1 place-item-btn"
                    onClick={getPlaceInfo}
                >
                    <i 
                        className={ fetchLoading.flag && fetchLoading.id === id ? 
                        'spinner-border spinner-border-sm operator-button': 'fa fa-eye'} 
                    ></i>
                </button>
                <button className="btn btn-success mr-1 mr-md-0  mb-md-1 user-item-btn"
                    onClick={getPlaceInfoForUpdate}
                >
                    <i 
                        className={ updateLoading.flag && updateLoading.id === id  ? 
                        'spinner-border spinner-border-sm operator-button': 'fa fa-pencil'} 
                    ></i>
                </button>
                <button className="btn btn-danger place-item-btn"
                    onClick={deletePlace}
                >
                    <i 
                        className={deleteLoading.flag && deleteLoading.id === id? 
                        'spinner-border spinner-border-sm operator-button': 'fa fa-trash'} 
                    ></i>
                </button>
            </div>
        </div>

     );
}
 
export default PlaceItem;